import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { Fade } from "react-awesome-reveal";
import { FaUserShield } from "react-icons/fa6";

import "swiper/css";
import "swiper/css/pagination";

const committeeTree = {
  Founder: [
    {
      name: "Late Md. Abdul Bari",
      role: "Founder",
      image: "https://i.ibb.co.com/60YKhJSj/founder.png",
    },
  ],
  Motowali: [
    {
      name: "Md. Mizanur Rahman",
      role: "Present Motowali",
      image: "https://i.ibb.co.com/NdFtgrDm/motowalli.jpg",
    },
    { name: "Md. Aminur Rahman", role: "Motowali Panel 1", image: "#" },
    {
      name: "Azizur Rahman",
      role: "Motowali Panel 2",
      image:
        "https://i.ibb.co.com/fzcYPKtH/Whats-App-Image-2025-02-16-at-14-31-51-f1ca74ef.jpg",
    },
    {
      name: "Update",
      role: "Motowali Panel 3",
      image: "https://i.ibb.co.com/842x5hB5/panel3.jpg",
    },
  ],
  "Active Committee": [
    { name: "Update", role: "President", image: "#" },

    { name: "Update", role: "Sr. Vice President", image: "#" },
    {
      name: "Emdadul Islam",
      role: "Vice President",
      image: "https://i.ibb.co.com/C3sg1jy5/jrvp.jpg",
    },
    {
      name: "Dr. Md. Amir Hossain",
      role: "General Secretary",
      image:
        "https://i.ibb.co.com/bj5kP8mN/Whats-App-Image-2025-02-16-at-13-24-57-0689d362.jpg",
    },
    { name: "Update", role: "Asst. General Secretary", image: "#" },
    { name: "Update", role: "Publicity Secretary", image: "#" },
    {
      name: "Hafez Md. Shariful Islam",
      role: "Library Secratary",
      image: "https://i.ibb.co.com/0yqLRrZ5/library.jpg",
    },
    {
      name: "Azizur Rahman",
      role: "Member",
      image:
        "https://i.ibb.co.com/fzcYPKtH/Whats-App-Image-2025-02-16-at-14-31-51-f1ca74ef.jpg",
    },
    { name: "Update", role: "Member", image: "#" },
    { name: "Update", role: "Member", image: "#" },
    { name: "Update", role: "Member", image: "#" },
    { name: "Update", role: "Member", image: "#" },
    { name: "Update", role: "Member", image: "#" },
  ],
};

// Reusable card snippet component for rendering consistent individual profiles
const ProfileCard = ({ member }) => {
  const hasValidImg = member.image && member.image !== "#";

  return (
    <div className="group relative bg-white border border-stone-100 rounded-2xl p-5 flex flex-col items-center text-center shadow-sm w-60 h-68 shrink-0 transform transition-all duration-500 hover:-translate-y-2 hover:shadow-xl">
      <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-emerald-700 to-green-900 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      {/* Avatar Handler */}
      <div className="relative mb-4">
        <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-stone-50 shadow-md relative bg-stone-100 flex items-center justify-center">
          {hasValidImg ? (
            <img
              src={member.image}
              alt={member.name}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <FaUserShield className="w-8 h-8 text-stone-300" />
          )}
        </div>
      </div>

      <h4 className="text-base font-bold text-gray-900 tracking-tight line-clamp-1 group-hover:text-emerald-950 transition-colors">
        {member.name}
      </h4>
      <p className="text-xs font-medium text-emerald-800 bg-emerald-50/60 px-3 py-1 rounded-full mt-1.5">
        {member.role}
      </p>
    </div>
  );
};

const MoshjidCommittee = () => {
  return (
    <div className="w-full py-16 bg-gradient-to-br from-stone-50 via-white to-green-50/20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <Fade direction="up" triggerOnce>
            <span className="text-sm font-semibold tracking-widest uppercase text-emerald-800 block mb-2">
              Leadership Board
            </span>
            <h2 className="text-4xl font-extrabold text-green-950 tracking-tight">
              Mosque Management Committee
            </h2>
          </Fade>
        </div>

        {/* Tree Layout Viewport Structure for Desktop Screens */}
        <div className="hidden md:flex flex-col space-y-12">
          {Object.entries(committeeTree).map(([roleGroup, members]) => (
            <div key={roleGroup} className="flex flex-col items-center w-full">
              <span className="text-xs font-bold uppercase tracking-widest text-stone-400 bg-stone-100 px-4 py-1 rounded-full mb-6">
                {roleGroup}
              </span>
              <div className="flex flex-wrap justify-center gap-8 w-full">
                {members.map((member, index) => (
                  <ProfileCard key={index} member={member} />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Unified Swiper Loop Layout Structure for Mobile Screens */}
        <div className="md:hidden w-full">
          {Object.entries(committeeTree).map(([roleGroup, members]) => (
            <div key={roleGroup} className="mb-10 last:mb-0">
              <span className="block text-center text-xs font-bold uppercase tracking-widest text-stone-400 mb-4">
                {roleGroup}
              </span>
              <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={16}
                slidesPerView={"auto"}
                centeredSlides={true}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3500, disableOnInteraction: false }}
                className="w-full !pb-12"
              >
                {members.map((member, index) => (
                  <SwiperSlide
                    key={index}
                    className="!w-auto flex justify-center"
                  >
                    <ProfileCard member={member} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoshjidCommittee;
